import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../../components/Seo';

function PoliticaColaboraciones() {
  return (
    <div className="page page--narrow">
      <Seo title="Política de colaboraciones" />
      <h1>Política de colaboraciones</h1>
      <p>
        Libros para Viajeros trabaja con editoriales, escritores, agencias y marcas en reseñas, contenido en redes
        y campañas de lanzamiento. El detalle de servicios y modalidades está en{' '}
        <Link to="/trabaja-conmigo">Trabaja conmigo</Link>.
      </p>
      <p>
        Toda colaboración remunerada se identifica de forma clara en el contenido correspondiente, conforme a la{' '}
        <Link to="/politica-editorial">política editorial</Link>.
      </p>
    </div>
  );
}

export default PoliticaColaboraciones;
